import { Injectable } from '@angular/core';
import { AppConfig, UvExplorerClient } from 'common';
import { Observable, Subject } from 'rxjs/Rx';
import { ValueEncoder } from 'DiscoveryEngine.TS/Utils';
import { EventListDto, EventDto } from 'UvExplorerServer.Dtos.TS/Events';

@Injectable()
export class EventsWebService {
	constructor(private appConfig: AppConfig, private uvExplorerClient: UvExplorerClient) {
		return;
	}

	public getEvents(scopeGuid: string, agentGuid: string, clientAgentGuid: string,
		schedDiscGuid: string, schedDiscResultGuid: string,
		category: string, source: string, level: string, description: string,
		sortBy: string, ascending: boolean, skip: number, limit: number): Observable<EventListDto> {

		let body = {
			get_events_request: {
				scope_guid: scopeGuid,
				agent_guid: agentGuid,
				client_agent_guid: clientAgentGuid,
				sched_disc_guid: schedDiscGuid,
				sched_disc_result_guid: schedDiscResultGuid,
				category: category,
				source: source,
				level: level,
				description: description,
				sort_by: sortBy,
				ascending: ValueEncoder.EncodeBoolean(ascending),
				skip: ValueEncoder.EncodeInteger(skip),
				limit: ValueEncoder.EncodeInteger(limit)
			}
		};

		let url = this.appConfig.dataServiceUrl + `api/data/events`;
		return this.uvExplorerClient.postObjSer(url, body, EventListDto);
	}

}